import React from 'react';

export function JobOperations() {

	return <div>

		{/* Overview */}
		<section className='expander collapsed'>
			<header>
				<button tabIndex={ -1 }><span>OVERVIEW <span className='options'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className='inner'>
				<div>
					<table className='sortable' cellPadding='0' cellSpacing='0'>
						<thead>
							<tr>
								<td></td>
								<td className='sorted'>Relay No.</td>
								<td className='relayNumberAccountingId'>Legacy ID</td>
								<td>Name</td>
								<td>Requires Delivery?</td>
								<td className='date'>Delivery Date</td>
								<td>Requires Install?</td>
								<td>Install Sheet</td>
								<td className='date'>Install Start Date</td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td></td>
								<td>JC-265 &nbsp; <span className="badge" style={{ backgroundColor: 'rgb(0, 40, 86)'}}><span>L</span></span></td>
								<td className='relayNumberAccountingId'>000000.00</td>
								<td>Kitchen &amp; Butler's Pantry</td>
								<td>
									<select className="select" placeholder="Select">
										<option value="" selected>Yes</option>
										<option value="">No</option>
									</select>
								</td>
								<td className='date'>–</td>
								<td>
									<select className="select" placeholder="Select">
										<option value="" selected>Yes</option>
										<option value="">No</option>
									</select>
								</td>
								<td className='date'>09/17/2022</td>
								<td></td>
							</tr>
							<tr>
								<td></td>
								<td>JC-266 &nbsp; <span className="badge" style={{ backgroundColor: 'rgb(0, 40, 86)'}}><span>L</span></span></td>
								<td className='relayNumberAccountingId'>000000.00</td>
								<td>Ensuite</td>
								<td>
									<select className="select" placeholder="Select">
										<option value="" selected>Yes</option>
										<option value="">No</option>
									</select>
								</td>
								<td className='date'>–</td>
								<td>
									<select className="select" placeholder="Select">
										<option value="" selected>Yes</option>
										<option value="">No</option>
									</select>
								</td>
								<td className='date'>09/17/2022</td>
								<td></td>
							</tr>
							<tr>
								<td></td>
								<td>JC-267 &nbsp; <span className="badge" style={{ backgroundColor: 'rgb(0, 40, 86)'}}><span>L</span></span></td>
								<td className='relayNumberAccountingId'>000000.00</td>
								<td>Basement Bar</td>
								<td>
									<select className="select" placeholder="Select">
										<option value="" selected>Yes</option>
										<option value="">No</option>
									</select>
								</td>
								<td className='date'>–</td>
								<td>
									<select className="select" placeholder="Select">
										<option value="" selected>Yes</option>
										<option value="">No</option>
									</select>
								</td>
								<td className='date'>09/17/2022</td>
								<td></td>
							</tr>
							<tr>
								<td></td>
								<td>CO-86 &nbsp; <span className="badge" style={{ backgroundColor: 'rgb(0, 40, 86)'}}><span>L</span></span></td>
								<td className='relayNumberAccountingId'>000000.00</td>
								<td>Basement Bar</td>
								<td>
									<select className="select" placeholder="Select">
										<option value="" selected>Yes</option>
										<option value="">No</option>
									</select>
								</td>
								<td className='date'>–</td>
								<td>
									<select className="select" placeholder="Select">
										<option value="">Yes</option>
										<option value="" selected>No</option>
									</select>
								</td>
								<td className='date'>–</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>

		{/* Delivery */}
		<section className='expander collapsed'>
			<header><button tabIndex={ -1 }><span>DELIVERY <span className='options'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'>
					<button className='icon iconOnly addItemWhite'><span></span></button>
				</div>
			</header>
			<div className=''>
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>JC-265 / JC-266 <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'>
							<button className='icon iconOnly contextMenu'><span></span></button>
						</div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='half' cellPadding='0' cellSpacing='0'>
								<tbody>
									<tr>
										<td></td>
										<td><strong>Delivery Date</strong></td>
										<td className='date'>
											<div className='DayPickerInput'><input placeholder='Select a Date' className='dataList' type='text' value='' /></div>
										</td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td><strong>Deliver Contracts</strong></td>
										<td><span className='readOnly'>JC-265 &bull; 000000.00 &bull; Kitchen &amp; Butler’s Pantry</span></td>
										<td></td>
									</tr>
								</tbody>
							</table>
							<table className='half' cellPadding='0' cellSpacing='0'>
								<tbody>
									<tr>
										<td></td>
										<td><strong>Who is Delivering?</strong></td>
										<td><input type='text' placeholder='Who is Delivering?' autoCapitalize='' autoCorrect='off' value=''></input></td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td><strong>Delivery Instructions</strong></td>
										<td><textarea placeholder='Delivery Instructions'></textarea></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>JC-267 <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'>
							<button className='icon iconOnly contextMenu'><span></span></button>
						</div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='half' cellPadding='0' cellSpacing='0'>
								<tbody>
									<tr>
										<td></td>
										<td><strong>Delivery Date</strong></td>
										<td className='date'>
											<div className='DayPickerInput'><input placeholder='Select a Date' className='dataList' type='text' value='' /></div>
										</td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td><strong>Deliver Contracts</strong></td>
										<td><span className='readOnly'>JC-267 &bull; 000000.00 &bull; Basement Bar</span></td>
										<td></td>
									</tr>
								</tbody>
							</table>
							<table className='half' cellPadding='0' cellSpacing='0'>
								<tbody>
									<tr>
										<td></td>
										<td><strong>Who is Delivering?</strong></td>
										<td><input type='text' placeholder='Who is Delivering?' autoCapitalize='' autoCorrect='off' value=''></input></td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td><strong>Delivery Instructions</strong></td>
										<td><textarea placeholder='Delivery Instructions'></textarea></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
			</div>
		</section>

		{/* Install */}
		<section className='expander expanded'>
			<header><button tabIndex={ -1 }><span>INSTALL <span className='options'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'>
					<button className='icon iconOnly addItemWhite'><span></span></button>
				</div>
			</header>
			<div className=''>

				{/* INSTALLATION - Example collapsed install with no date and no installer */}
				<section className='expander collapsed'>
					<header><button tabIndex={ -1 }><span className='icon scheduleNone red'>No Date <span className='subtitle red'>No Installer Assigned</span> <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'>
							<button className='icon iconOnly print'><span></span></button>
							<button className='icon iconOnly contextMenu'><span></span></button>
						</div>
					</header>
					<div>
						<div className='inner clearfix'>
							All the stuff goes here
						</div>
					</div>
				</section>

				{/* INSTALLATION - Example completed install - read only */}
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span className='icon scheduleComplete'>09/10/2022 <span className='subtitle'>N. Nickerson</span> <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'>
							<button className='icon iconOnly print'><span></span></button>
							<button className='icon iconOnly contextMenu'><span></span></button>
						</div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='half' cellPadding='0' cellSpacing='0'>
								<tbody>
									<tr>
										<td></td>
										<td><strong>Install Start Date</strong></td>
										<td>09/17/2022</td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td><strong>Install Completion Date</strong></td>
										<td><button className="icon iconLabel iconRight editCell"><span>09/18/2022</span></button></td>
										<td></td>
									</tr>
								</tbody>
							</table>
							<table className='half' cellPadding='0' cellSpacing='0'>
								<tbody>
									<tr>
										<td></td>
										<td><strong>Installer</strong></td>
										<td>Nate Nickerson</td>
										<td></td>
									</tr>
									{/* Note that after install completion, the Install Notes table is removed and the row with notes is moved up into the same table as the Installer */}
									<tr>
										<td></td>
										<td><strong>Install Notes</strong></td>
										<td>Please close door behind you when entering the home. Dog will run out.</td>
										<td></td>
									</tr>
								</tbody>
							</table>
							<table className='installerPay' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className='contract'>Contract</td>
										<td className='installSheet'><span className='readOnly'>Install Sheet</span></td>
										<td className='category'><span className='readOnly'>Category</span></td>
										<td className='price'><span className='readOnly'>Amount</span></td>
										<td className='actions'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>

									{/* CONTRACTS - repeat this tr for each contract */}
									<tr className='contractRow'>
										<td></td>
										<td className='contract'><span className='readOnly'><strong>JC-265 • 000000.00</strong><br/>Kitchen &amp; Butler’s Pantry</span></td>
										<td className='innerTable' colSpan={4}>
											
											{/* INSTALL SHEET - Repeat this table for each install sheet */}
											<table className='installSheetTable' cellPadding='0' cellSpacing='0'>
												<td className='installSheet'><span className='readOnly'><strong>2. Install</strong></span></td>
												<td className='innerTable'>
													<table className='compact' cellPadding='0' cellSpacing='0'>
														<tbody>
															{/* LINE ITEM - example Added line item */}
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Incomplete hardware install</span></td>
																<td className='price'><span className='readOnly'>-$350.00</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
															{/* LINE ITEM - example fixed category line item */}
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Cabinets</span></td>
																<td className='price'><span className='readOnly'>$473.40</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Appliances</span></td>
																<td className='price'><span className='readOnly'>$1,854.00</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Toe Kicks &amp; FBM</span></td>
																<td className='price'><span className='readOnly'>$786.00</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Fillers &amp; Columns</span></td>
																<td className='price'><span className='readOnly'>$250.50</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
														</tbody>
														<tfoot className='subtotal'>
															<tr>
																<td></td>
																<td className='right'>Subtotal</td>
																<td className='price'><span className='readOnly'>$3,013.90</span></td>
																<td className='actions'><button className='icon iconOnly openWindow'><span></span></button></td>
																<td></td>
															</tr>
														</tfoot>
													</table> 
												</td>
												<td></td>
											</table>

										</td>
										<td></td>
									</tr>
								</tbody>
								<tfoot className='total'>
									<tr>
										<td></td>
										<td></td>
										<td></td>
										<td className='right'>Installer Pay Total</td>
										<td className='cost'><span className='readOnly'>$3,604.90</span></td>
										<td className='actions'></td>
										<td></td>
									</tr>
								</tfoot>
							</table>
						</div>
					</div>
				</section>

				{/* INSTALLATION - Repeat for each install  */}
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span className='icon schedule'>09/17/2022 <span className='subtitle red'>No Installer Assigned</span> <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'>
							<button className='icon iconOnly print'><span></span></button>
							<button className='icon iconOnly contextMenu'><span></span></button>
						</div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='half' cellPadding='0' cellSpacing='0'>
								<tbody>
									<tr>
										<td></td>
										<td><strong>Install Start Date</strong></td>
										<td className='date'>
											<div className='DayPickerInput'><input placeholder='Select a Date' className='dataList' type='text' value='09/17/2022' />
												{/* <div className='DayPickerInput-OverlayWrapper' tabIndex={0}>
													<div className='DayPickerInput-Overlay'>
														<div className='DayPicker' lang='en'>
															<div className='DayPicker-wrapper' tabIndex={0}>
																<div className='DayPicker-NavBar'><span tabIndex={0} role='button' aria-label='Previous Month' className='DayPicker-NavButton DayPicker-NavButton--prev'></span><span tabIndex={0} role='button' aria-label='Next Month' className='DayPicker-NavButton DayPicker-NavButton--next'></span></div>
																<div className='DayPicker-Months'>
																	<div className='DayPicker-Month' role='grid'>
																		<div className='DayPicker-Caption' role='heading' aria-live='polite'>
																			<div>December 2022</div>
																		</div>
																		<div className='DayPicker-Weekdays' role='rowgroup'>
																			<div className='DayPicker-WeekdaysRow' role='row'>
																				<div className='DayPicker-Weekday' role='columnheader'><abbr title='Sunday'>Su</abbr>
																				</div>
																				<div className='DayPicker-Weekday' role='columnheader'><abbr title='Monday'>Mo</abbr>
																				</div>
																				<div className='DayPicker-Weekday' role='columnheader'><abbr title='Tuesday'>Tu</abbr>
																				</div>
																				<div className='DayPicker-Weekday' role='columnheader'><abbr title='Wednesday'>We</abbr>
																				</div>
																				<div className='DayPicker-Weekday' role='columnheader'><abbr title='Thursday'>Th</abbr>
																				</div>
																				<div className='DayPicker-Weekday' role='columnheader'><abbr title='Friday'>Fr</abbr>
																				</div>
																				<div className='DayPicker-Weekday' role='columnheader'><abbr title='Saturday'>Sa</abbr>
																				</div>
																			</div>
																		</div>
																		<div className='DayPicker-Body' role='rowgroup'>
																			<div className='DayPicker-Week' role='row'>
																				<div aria-disabled='true' className='DayPicker-Day DayPicker-Day--outside'></div>
																				<div aria-disabled='true' className='DayPicker-Day DayPicker-Day--outside'></div>
																				<div aria-disabled='true' className='DayPicker-Day DayPicker-Day--outside'></div>
																				<div aria-disabled='true' className='DayPicker-Day DayPicker-Day--outside'></div>
																				<div className='DayPicker-Day' tabIndex={0} role='gridcell' aria-label='Thu Dec 01 2022'
																					aria-disabled='false' aria-selected='false'>1</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Fri Dec 02 2022' aria-disabled='false' aria-selected='false'>2</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Sat Dec 03 2022' aria-disabled='false' aria-selected='false'>3</div>
																			</div>
																			<div className='DayPicker-Week' role='row'>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Sun Dec 04 2022' aria-disabled='false' aria-selected='false'>4</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Mon Dec 05 2022' aria-disabled='false' aria-selected='false'>5</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Tue Dec 06 2022' aria-disabled='false' aria-selected='false'>6</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Wed Dec 07 2022' aria-disabled='false' aria-selected='false'>7</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Thu Dec 08 2022' aria-disabled='false' aria-selected='false'>8</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Fri Dec 09 2022' aria-disabled='false' aria-selected='false'>9</div>
																				<div className='DayPicker-Day DayPicker-Day--today' tabIndex={-1} role='gridcell'
																					aria-label='Sat Dec 10 2022' aria-disabled='false' aria-selected='false'>10
																				</div>
																			</div>
																			<div className='DayPicker-Week' role='row'>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Sun Dec 11 2022' aria-disabled='false' aria-selected='false'>11
																				</div>
																				<div className='DayPicker-Day overLimit' tabIndex={-1} role='gridcell'
																					aria-label='Mon Dec 12 2022' aria-disabled='false' aria-selected='false'>12
																				</div>
																				<div className='DayPicker-Day overLimit' tabIndex={-1} role='gridcell'
																					aria-label='Tue Dec 13 2022' aria-disabled='false' aria-selected='false'>13
																				</div>
																				<div className='DayPicker-Day overLimit' tabIndex={-1} role='gridcell'
																					aria-label='Wed Dec 14 2022' aria-disabled='false' aria-selected='false'>14
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Thu Dec 15 2022' aria-disabled='false' aria-selected='false'>15
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Fri Dec 16 2022' aria-disabled='false' aria-selected='false'>16
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Sat Dec 17 2022' aria-disabled='false' aria-selected='false'>17
																				</div>
																			</div>
																			<div className='DayPicker-Week overLimit' role='row'>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Sun Dec 18 2022' aria-disabled='false' aria-selected='false'>18
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Mon Dec 19 2022' aria-disabled='false' aria-selected='false'>19
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Tue Dec 20 2022' aria-disabled='false' aria-selected='false'>20
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Wed Dec 21 2022' aria-disabled='false' aria-selected='false'>21
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Thu Dec 22 2022' aria-disabled='false' aria-selected='false'>22
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Fri Dec 23 2022' aria-disabled='false' aria-selected='false'>23
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Sat Dec 24 2022' aria-disabled='false' aria-selected='false'>24
																				</div>
																			</div>
																			<div className='DayPicker-Week' role='row'>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Sun Dec 25 2022' aria-disabled='false' aria-selected='false'>25
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Mon Dec 26 2022' aria-disabled='false' aria-selected='false'>26
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Tue Dec 27 2022' aria-disabled='false' aria-selected='false'>27
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Wed Dec 28 2022' aria-disabled='false' aria-selected='false'>28
																				</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Thu Dec 29 2022' aria-disabled='false' aria-selected='false'>29
																				</div>
																				<div className='DayPicker-Day DayPicker-Day--selected' tabIndex={-1} role='gridcell'
																					aria-label='Fri Dec 30 2022' aria-disabled='false' aria-selected='true'>30</div>
																				<div className='DayPicker-Day' tabIndex={-1} role='gridcell'
																					aria-label='Sat Dec 31 2022' aria-disabled='false' aria-selected='false'>31
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div> */}
											</div>
										</td>
										<td></td>
									</tr>
								</tbody>
							</table>
							<table className='half' cellPadding='0' cellSpacing='0'>
								<tbody>
									<tr>
										<td></td>
										<td><strong>Installer</strong></td>
										<td>
											<select className="select" placeholder="Select">
												<option value="">Select</option>
												<option value="">Nate Nickerson</option>
												<option value="">Minstaller McGee</option>
											</select>
										</td>
										<td></td>
									</tr>
								</tbody>
							</table>
							<table className='installNotes' cellPadding='0' cellSpacing='0'>
								<tbody>
									<tr>
										<td></td>
										<td><strong>Install Notes</strong></td>
										<td><textarea placeholder='Install Notes'></textarea></td>
										<td></td>
									</tr>
								</tbody>
							</table>
							<table className='installerPay' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className='contract'>Contract</td>
										<td className='installSheet'><span className='readOnly'>Install Sheet</span></td>
										<td className='category'><span className='readOnly'>Category</span></td>
										<td className='price'><span className='readOnly'>Amount</span></td>
										<td className='actions'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>

									{/* CONTRACTS - repeat this tr for each contract */}
									<tr className='contractRow'>
										<td></td>
										<td className='contract'><span className='readOnly'><strong>JC-265 • 000000.00</strong><br/>Kitchen &amp; Butler’s Pantry</span></td>
										<td className='innerTable' colSpan={4}>
											
											{/* INSTALL SHEET - Repeat this table for each install sheet */}
											<table className='installSheetTable' cellPadding='0' cellSpacing='0'>
												<td className='installSheet'><span className='readOnly'><strong>2. Install</strong></span></td>
												<td className='innerTable'>
													<table className='compact' cellPadding='0' cellSpacing='0'>
														<tbody>
															{/* Add Line Item control */}
															<tr className=''>
																<td></td>
																<td className='category'><input type='text' placeholder='Adjustment - Enter a Description' autoCapitalize='' autoCorrect='off' value='' /></td>
																<td className='price'><input type='text' placeholder='0.00' value='$0.00' /></td>
																<td className='actions'><button className='icon iconOnly addItem'><span></span></button></td>
																<td></td>
															</tr>
															{/* LINE ITEM - example Added line item */}
															<tr className='added'>
																<td></td>
																<td className='category'><input type='text' placeholder='Enter a Description' autoCapitalize='' autoCorrect='off' value='Incomplete hardware install' /></td>
																<td className='price'><input type='text' placeholder='0.00' value='-$350.00' /></td>
																<td className='actions'><button className='icon iconOnly contextMenu'><span></span></button></td>
																<td></td>
															</tr>
															{/* LINE ITEM - example fixed category line item */}
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Cabinets</span></td>
																<td className='price'><span className='readOnly'>$473.40</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Appliances</span></td>
																<td className='price'><span className='readOnly'>$1,854.00</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Toe Kicks &amp; FBM</span></td>
																<td className='price'><span className='readOnly'>$786.00</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Fillers &amp; Columns</span></td>
																<td className='price'><span className='readOnly'>$250.50</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
														</tbody>
														<tfoot className='subtotal'>
															<tr>
																<td></td>
																<td className='right'>Subtotal</td>
																<td className='price'><span className='readOnly'>$3,013.90</span></td>
																<td className='actions'><button className='icon iconOnly openWindow'><span></span></button></td>
																<td></td>
															</tr>
														</tfoot>
													</table> 
												</td>
												<td></td>
											</table>
											
											{/* INSTALL SHEET - Just another example Install Sheet */}
											<table className='installSheetTable' cellPadding='0' cellSpacing='0'>
												<td className='installSheet'><span className='readOnly'><strong>3. Post-Install Glass Doors</strong></span></td>
												<td className='innerTable'>
													<table className='compact' cellPadding='0' cellSpacing='0'>
														<tbody>
															<tr className=''>
																<td></td>
																<td className='category'><input type='text' placeholder='Adjustment - Enter a Description' autoCapitalize='' autoCorrect='off' value='' /></td>
																<td className='price'><input type='text' placeholder='0.00' value='$0.00' /></td>
																<td className='actions'><button className='icon iconOnly addItem'><span></span></button></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Specials</span></td>
																<td className='price'><span className='readOnly'>$325.00</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
														</tbody>
														<tfoot className='subtotal'>
															<tr>
																<td></td>
																<td className='right'>Subtotal</td>
																<td className='price'><span className='readOnly'>$325.00</span></td>
																<td className='actions'><button className='icon iconOnly openWindow'><span></span></button></td>
																<td></td>
															</tr>
														</tfoot>
													</table> 
												</td>
												<td></td>
											</table>

										</td>
										<td></td>
									</tr>

									{/* CONTRACT - just another contract example */}
									<tr className='contractRow'>
										<td></td>
										<td className='contract'><span className='readOnly'><strong>JC-266 • 000000.00</strong><br/>Ensuite</span></td>
										<td className='innerTable' colSpan={4}>
											<table className='installSheetTable' cellPadding='0' cellSpacing='0'>
												<td className='installSheet'><span className='readOnly'><strong>1. Install</strong></span></td>
												<td className='innerTable'>
													<table className='compact' cellPadding='0' cellSpacing='0'>
														<tbody>
															<tr className=''>
																<td></td>
																<td className='category'><input type='text' placeholder='Adjustment - Enter a Description' autoCapitalize='' autoCorrect='off' value='' /></td>
																<td className='price'><input type='text' placeholder='0.00' value='$0.00' /></td>
																<td className='actions'><button className='icon iconOnly addItem'><span></span></button></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Cabinets</span></td>
																<td className='price'><span className='readOnly'>$125.20</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Toe Kicks &amp; FBM</span></td>
																<td className='price'><span className='readOnly'>$75.30</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
															<tr className='added'>
																<td></td>
																<td className='category'><span className='readOnly'>Fillers &amp; Columns</span></td>
																<td className='price'><span className='readOnly'>$65.50</span></td>
																<td className='actions'></td>
																<td></td>
															</tr>
														</tbody>
														<tfoot className='subtotal'>
															<tr>
																<td></td>
																<td className='right'>Subtotal</td>
																<td className='price'><span className='readOnly'>$266.00</span></td>
																<td className='actions'><button className='icon iconOnly openWindow'><span></span></button></td>
																<td></td>
															</tr>
														</tfoot>
													</table> 
												</td>
												<td></td>
											</table>
										</td>
										<td></td>
									</tr>
								</tbody>
								<tfoot className='total'>
									<tr>
										<td></td>
										<td></td>
										<td></td>
										<td className='right'>Installer Pay Total</td>
										<td className='cost'><span className='readOnly'>$3,604.90</span></td>
										<td className='actions'></td>
										<td></td>
									</tr>
								</tfoot>
							</table>

							<div className='actions prominent'>
								<button className='action iconLabel markComplete'><span>MARK INSTALL COMPLETE</span></button>
							</div>
						</div>
					</div>
				</section>

			</div>
		</section>

		{/* Internal Ops Notes */}
		<section className='expander collapsed'>
			<header>
				<button tabIndex={ -1 }><span>INTERNAL OPS NOTES <button tabIndex={ -1 } className='icon iconOnly info'><span></span></button> <span className='options'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className='inner'>
				<div>
					<table className='compact notes' cellPadding='0' cellSpacing='0'>
						<tbody>
							<tr>
								<td></td>
								<td className='note'><textarea placeholder='Add a Note'></textarea></td>
								<td className='action'><button className='icon iconOnly addItem'><span></span></button></td>
								<td></td>
							</tr>
						</tbody>
					</table>
					<table className='sortable' cellPadding='0' cellSpacing='0'>
						<thead>
							<tr>
								<td></td>
								<td className='sorted'>Date</td>
								<td className=''>Note</td>
								<td className=''>Added By</td>
								<td></td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							<tr className='added'>
								<td></td>
								<td className='date'><strong>04/04/22</strong></td>
								<td className='note'>House is unoccupied 9am-5pm but there are two small dogs inside. Take care to close the door behind you whenever you leave the home.</td>
								<td className='addedBy'>Dwight Schrute</td>
								<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>

		{/* History */}
		<section className='expander collapsed'>
			<header><button tabIndex={ -1 }><span>HISTORY <span className='options'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>Estimate 1 <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'></div>
					</header>
					<div className='inner'>
						<table className='sortable' cellPadding='0' cellSpacing='0'>
							<thead>
								<tr>
									<td></td>
									<td className='sorted'>Date</td>
									<td className=''>Description</td>
									<td className=''>Legacy Personnel</td>
									<td></td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td></td>
									<td>01/30/2018</td>
									<td>Order Processed</td>
									<td>Natasha Porfoun</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/29/2018</td>
									<td>Approved</td>
									<td>Natasha Porfoun</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/29/2018</td>
									<td>Pending Approval</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/29/2018</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/29/2018</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/27/2018</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/27/2018</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/27/2018</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/27/2018</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/27/2018</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/27/2018</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/22/2018</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/22/2018</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/21/2018</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/21/2018</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/21/2018</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/21/2018</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/21/2018</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/21/2018</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/21/2018</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>01/02/2018</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>12/18/2017</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>12/18/2017</td>
									<td>Unlocked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>11/07/2017</td>
									<td>Locked</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>11/07/2017</td>
									<td>Estimate</td>
									<td>Michael Burr</td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>Kitchen &amp; Bath <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'></div>
					</header>
					<div className='inner'>
						<table className='sortable' cellPadding='0' cellSpacing='0'>
							<thead>
								<tr>
									<td></td>
									<td className='sorted'>Date</td>
									<td className=''>Description</td>
									<td className=''>Legacy Personnel</td>
									<td></td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td></td>
									<td>09/11/2018</td>
									<td>Approved</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>09/11/2018</td>
									<td>Pending Approval</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>09/11/2018</td>
									<td>Locked</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>09/11/2018</td>
									<td>Unlocked</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>09/07/2018</td>
									<td>Locked</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>09/07/2018</td>
									<td>Unlocked</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>08/13/2018</td>
									<td>Locked</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>07/30/2018</td>
									<td>Unlocked</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>07/30/2018</td>
									<td>Locked</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>07/30/2018</td>
									<td>Estimate</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>Just a test <span className='options'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'></div>
					</header>
					<div className='inner'>
						<table className='sortable' cellPadding='0' cellSpacing='0'>
							<thead>
								<tr>
									<td></td>
									<td className='sorted'>Date</td>
									<td className=''>Description</td>
									<td className=''>Legacy Personnel</td>
									<td></td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td></td>
									<td>06/03/2019</td>
									<td>Rejected</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>06/03/2019</td>
									<td>Pending Approval</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>06/03/2019</td>
									<td>Locked</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>11/15/2018</td>
									<td>Estimate</td>
									<td>Jeremy Zeiders</td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
			</div>
		</section>

		{/* New Calendar Control */}
		<div className="modal out" style={{ zIndex: '100'}}>
			<div className="popup right right" style={{ inset: '520px auto auto 200px'}}>
				<div className="wedge"></div>
				<div className="container" style={{ maxWidth: '775px', maxHeight: '614.484px' }}>
					<div className="content" style={{ maxHeight: '614.484px' }}> {/* this level was missing from our standard popup structure - can we add it? */} 
						<div className="rdp ">
							<div className="rdp-months">
								<div className="rdp-month rdp-caption_start rdp-caption_end">
									<div className="rdp-caption">
										<div className="rdp-caption_label" aria-live="polite" role="presentation" id="react-day-picker-2">March 2023</div>
										<div className="rdp-nav">
											<button name="previous-month" aria-label="Go to previous month" className="rdp-button_reset rdp-button rdp-nav_button rdp-nav_button_previous" type="button">
												<svg width="16px" height="16px" viewBox="0 0 120 120" className="rdp-nav_icon">
													<path d="M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z" fill="currentColor" fill-rule="nonzero"></path>
												</svg>
											</button>
											<button name="next-month" aria-label="Go to next month" className="rdp-button_reset rdp-button rdp-nav_button rdp-nav_button_next" type="button">
												<svg width="16px" height="16px" viewBox="0 0 120 120" className="rdp-nav_icon">
													<path d="M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z" fill="currentColor"></path>
												</svg>
											</button>
										</div>
									</div>
									<table className="rdp-table" role="grid" aria-labelledby="react-day-picker-2">
										<thead className="rdp-head">
											<tr className="rdp-head_row">
												<th scope="col" className="rdp-head_cell" aria-label="Sunday">SU</th>
												<th scope="col" className="rdp-head_cell" aria-label="Monday">MO</th>
												<th scope="col" className="rdp-head_cell" aria-label="Tuesday">TU</th>
												<th scope="col" className="rdp-head_cell" aria-label="Wednesday">WE</th>
												<th scope="col" className="rdp-head_cell" aria-label="Thursday">TH</th>
												<th scope="col" className="rdp-head_cell" aria-label="Friday">FR</th>
												<th scope="col" className="rdp-head_cell" aria-label="Saturday">SA</th>
											</tr>
										</thead>
										<tbody className="rdp-tbody" role="rowgroup">
											<tr className="rdp-row">
												<td className="rdp-cell" role="presentation">
													<div role="gridcell"></div>
												</td>
												<td className="rdp-cell" role="presentation">
													<div role="gridcell"></div>
												</td>
												<td className="rdp-cell" role="presentation">
													<div role="gridcell"></div>
												</td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-button_reset rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">1</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">2</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">3</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">4</button></td>
											</tr>
											<tr className="rdp-row overLimit">
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">5</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">6</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">7</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">8</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">9</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">10</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">11</button></td>
											</tr>
											<tr className="rdp-row">
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day rdp-day_today" role="gridcell" tabIndex={ -1 } type="button">12</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">13</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day overLimit" role="gridcell" tabIndex={ -1 } type="button">14</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day overLimit" role="gridcell" tabIndex={ -1 } type="button">15</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">16</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day overLimit" role="gridcell" tabIndex={ -1 } type="button">17</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">18</button></td>
											</tr>
											<tr className="rdp-row">
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day rdp-day_selected" role="gridcell" tabIndex={ -1 } type="button">19</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">20</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">21</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">22</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">23</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">24</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">25</button></td>
											</tr>
											<tr className="rdp-row">
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">26</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">27</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">28</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">29</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ 0 } type="button">30</button></td>
												<td className="rdp-cell" role="presentation"><button name="day" className="rdp-b rdp-button rdp-day" role="gridcell" tabIndex={ -1 } type="button">31</button></td>
												<td className="rdp-cell" role="presentation">
													<div role="gridcell"></div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		{/* Override Schedule Limits */}
		<div className='modal out'>
			<div className='alert'>
				<section>
					<header><span>Override Schedule Limits?</span></header>
					<div className='content'>
						The date you selected will cause the daily or weekly schedule to be over limits. Enter an authorization code below to override and accept the selected date. 
						<input type='text' placeholder='Enter override code' autoCapitalize='' autoCorrect='off' value='' />
						<div className='actions'>
							{/* <button onClick={popModal}><span>Cancel</span></button> */}
							<button><span>Cancel</span></button>
							<button className='action disabled'><span>Override</span></button>
						</div>
					</div>
				</section>
			</div>
		</div>

		{/* Install Complete */}
		<div className='modal out'>
			<div className='alert'>
				<section>
					<header><span>Install Complete</span></header>
					<div className='content'>
						This will release the Installer Pay Total minus the 10% holdback and will trigger an inspection by the Field Supervisor.
						<div className='DayPickerInput'><input placeholder='Select Install Completion Date' className='dataList' type='text' value='' /></div>
						<textarea placeholder='Optional Note'></textarea>
						<div className='actions'>
							{/* <button onClick={popModal}><span>Cancel</span></button> */}
							<button><span>Cancel</span></button>
							<button className='action disabled'><span>Mark Complete</span></button>
						</div>
					</div>
				</section>
			</div>
		</div>

		{/* Add/Edit Delivery/Install */}
		<div className='modal out'>
			<div className='window'>
				<header><button className='cancel'><span>Cancel</span> </button><span>New Delivery</span><button className='disabled action save'><span>SAVE</span></button></header>
				<div className='views'>
					<div className='content in scrollable'>
						<section>
							<div className='inner'>
								<table className='centered' cellPadding='0' cellSpacing='0'>
									<tbody>
										<tr className=''>
											<td></td>
											<td><strong>Select Contracts</strong></td>
											<td>
												<label className="disabled"><input type="checkbox" placeholder="" /> JC-265 &bull; 000000.00 &bull; Kitchen &amp; Butler’s Pantry</label>
												<label className="disabled"><input type="checkbox" placeholder="" /> JC-266 &bull; 000000.00 &bull; Ensuite</label>
												<label><input type="checkbox" placeholder="" /> JC-267 &bull; 000000.00 &bull; Butler's Bar</label>
											</td>
											<td></td>
										</tr>
									</tbody>
								</table>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>

		{/* Installer Pay Details */}
		<div className='modal out'>
			<div className='window'>
				<header><button className='icon iconOnly printWhite'><span></span></button><span>JC-265 &bull; 000000.00 &bull; Installer Pay Details</span><button className='close'><span>Close</span></button></header>
				<div className='views'>
					<div className='content in scrollable'>
						
						{/* Example Expanded Section */}
						<section className='expander expanded'>
							<header><button tabIndex={ -1 }><span>CABINETS <span className='options'></span></span></button>
								<div className='icon iconExpander'><span></span><span></span></div>
								<div className='actions'></div>
							</header>
							<div className=''>
								<div className='inner'>
									<table className='compact prepopulated' cellPadding='0' cellSpacing='0'>
										<thead>
											<tr>
												<td></td>
												<td><span className='readOnly'>Description</span></td>
												<td className='type'><span className='readOnly'>Type</span></td>
												<td className='cost'><span className='readOnly'>Unit Value</span></td>
												<td className='cost'><span className='readOnly'>Cost Per</span></td>
												<td className='quantity'><span className='readOnly'>Quantity</span></td>
												<td className='cost'><span className='readOnly'>Cost</span></td>
												<td></td>
											</tr>
										</thead>
										<tbody>
											<tr className='added readOnly populated'>
												<td></td>
												<td><span className='readOnly'>Total number of Cabinets</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>1</span></td>
												<td className='cost'><span className='readOnly'>$12.25</span></td>
												<td className='quantity'><span className='readOnly'>1</span></td>
												<td className='cost'><span className='readOnly'>$12.25</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Units Over 36' up to 60' in Height</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>0.5</span></td>
												<td className='cost'><span className='readOnly'>$6.13</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Base, Wall &amp; Vanity Units With 3 Doors</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>1</span></td>
												<td className='cost'><span className='readOnly'>$12.25</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>All Sink/Cooktop Cabinets</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>0.75</span></td>
												<td className='cost'><span className='readOnly'>$9.19</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Range Top Cooktops (front control panel)</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>5</span></td>
												<td className='cost'><span className='readOnly'>$61.25</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Farm sink cabinet or modify std cabinet for farm sink</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>5</span></td>
												<td className='cost'><span className='readOnly'>$61.25</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Base Drawer Cabinets</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>0.3</span></td>
												<td className='cost'><span className='readOnly'>$3.67</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Blind Corners and BCCQ cabinets</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>1</span></td>
												<td className='cost'><span className='readOnly'>$12.25</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Floating cabinets</span></td>
												<td><span className='readOnly'>Per Cabinet</span></td>
												<td className='cost'><span className='readOnly'>2</span></td>
												<td className='cost'><span className='readOnly'>$24.50</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Finish Panel for Below Floating Cabinet (If Required)</span></td>
												<td><span className='readOnly'>Per Panel</span></td>
												<td className='cost'><span className='readOnly'>1</span></td>
												<td className='cost'><span className='readOnly'>$12.25</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Cabinets Over 24' Deep</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>1</span></td>
												<td className='cost'><span className='readOnly'>$12.25</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Wall Angle Cabinets</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>0.5</span></td>
												<td className='cost'><span className='readOnly'>$6.13</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Stacked cabinets up to 9'1'</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>1</span></td>
												<td className='cost'><span className='readOnly'>$12.25</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Stacked cabinets over 9'1'</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>2</span></td>
												<td className='cost'><span className='readOnly'>$24.50</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Custom Range Hood </span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>5</span></td>
												<td className='cost'><span className='readOnly'>$61.25</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Tall Units Up to and Including 86' in Height</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>1</span></td>
												<td className='cost'><span className='readOnly'>$12.25</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Tall Units Over 86' in Height</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>2</span></td>
												<td className='cost'><span className='readOnly'>$24.50</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Island/Peninsula Cabinets (Including Stub Walls)</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>0.5</span></td>
												<td className='cost'><span className='readOnly'>$6.13</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
											<tr className='added readOnly'>
												<td></td>
												<td><span className='readOnly'>Console Vanity</span></td>
												<td><span className='readOnly'>Each</span></td>
												<td className='cost'><span className='readOnly'>4</span></td>
												<td className='cost'><span className='readOnly'>$49.00</span></td>
												<td className='quantity'><span className='readOnly'>0</span></td>
												<td className='cost'><span className='readOnly'>$0.00</span></td>
												<td></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</section>
						
						{/* Example Collapsed Sections */}
						<section className='expander collapsed'>
							<header><button tabIndex={ -1 }><span>ANOTHER SECTION HERE <span className='options'></span></span></button>
								<div className='icon iconExpander'><span></span><span></span></div>
								<div className='actions'></div>
							</header>
							<div className=''>
								<div className='inner'>
									table here
								</div>
							</div>
						</section>

						<section className='expander collapsed'>
							<header><button tabIndex={ -1 }><span>YET ANOTHER SECTION HERE <span className='options'></span></span></button>
								<div className='icon iconExpander'><span></span><span></span></div>
								<div className='actions'></div>
							</header>
							<div className=''>
								<div className='inner'>
									table here
								</div>
							</div>
						</section>

						<section className='expander collapsed'>
							<header><button tabIndex={ -1 }><span>SECTIONS ABOUND <span className='options'></span></span></button>
								<div className='icon iconExpander'><span></span><span></span></div>
								<div className='actions'></div>
							</header>
							<div className=''>
								<div className='inner'>
									table here
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>

		{/* Context Menus - provided as a reference for button classes and labels */}

		{/* Delivery */}
		<div className='modal out'>
			<div className='popup left'>
				<div className='wedge'></div>
				<div className='container'>
					<div className='content scrollable'>
						<ul className='menu'>
							<li><a className='button icon iconLabel editItem'><span>Edit Delivery</span></a></li>
							<li><a className='button icon iconLabel removeItem delete'><span>Delete</span></a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		{/* Install */}
		<div className='modal out'>
			<div className='popup left'>
				<div className='wedge'></div>
				<div className='container'>
					<div className='content scrollable'>
						<ul className='menu'>
							<li><a className='button icon iconLabel editItem'><span>Edit Install</span></a></li>
							<li><a className='button icon iconLabel removeItem delete'><span>Delete</span></a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		{/* Installer Pay Line Item */}
		<div className='modal out'>
			<div className='popup left'>
				<div className='wedge'></div>
				<div className='container'>
					<div className='content scrollable'>
						<ul className='menu'>
							<li><a className='button icon iconLabel duplicateItem'><span>Duplicate</span></a></li>
							<li><a className='button icon iconLabel removeItem delete'><span>Delete</span></a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		

	</div>;
}